import { render, staticRenderFns } from "./_Aspirant.vue?vue&type=template&id=79b8d193"
import script from "./_Aspirant.vue?vue&type=script&lang=js"
export * from "./_Aspirant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports